import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function IntroOverlay({ text = "Bienvenido al cuento" }) {
  const [show, setShow] = useState(true);

  useEffect(() => {
    if (sessionStorage.getItem("pextlan_intro_shown") === "1") {
      setShow(false);
      return;
    }
    const t = setTimeout(() => {
      sessionStorage.setItem("pextlan_intro_shown", "1");
      setShow(false);
    }, 3200);
    return () => clearTimeout(t);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="intro-overlay"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-0 z-[100] flex items-center justify-center bg-[var(--c-bg-deep)] overflow-hidden"
        >
          {/* Expanding portal ring */}
          <motion.div
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: [0, 1.2, 1.05], opacity: [0, 1, 1] }}
            transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
            className="absolute"
          >
            <div className="w-[520px] h-[520px] rounded-full border-2 border-[var(--c-firefly-gold)]/40 portal-glow" />
            <div className="absolute inset-8 rounded-full border border-[var(--c-bio-green)]/40" />
            <div className="absolute inset-16 rounded-full border border-[var(--c-firefly-gold)]/20" />
          </motion.div>

          {/* Sparkle particles */}
          {Array.from({ length: 30 }).map((_, i) => {
            const angle = (i / 30) * Math.PI * 2;
            const radius = 220 + Math.random() * 60;
            const x = Math.cos(angle) * radius;
            const y = Math.sin(angle) * radius;
            return (
              <motion.span
                key={i}
                initial={{ x: 0, y: 0, opacity: 0, scale: 0 }}
                animate={{ x, y, opacity: [0, 1, 0], scale: [0, 1.5, 0.5] }}
                transition={{ duration: 2 + Math.random(), delay: 0.4 + Math.random() * 0.6, ease: "easeOut" }}
                className="absolute w-2 h-2 rounded-full"
                style={{
                  background: "radial-gradient(circle, #FFF7C2 0%, #F1C36B 50%, transparent 80%)",
                  filter: "blur(0.5px) drop-shadow(0 0 8px #F8E59C)",
                }}
              />
            );
          })}

          {/* Center text */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.6 }}
            className="relative text-center"
          >
            <motion.div
              initial={{ letterSpacing: "-0.05em" }}
              animate={{ letterSpacing: "0.04em" }}
              transition={{ duration: 1.4, delay: 0.6 }}
              className="font-fairy text-5xl sm:text-7xl text-[var(--c-firefly-gold)]"
              style={{ textShadow: "0 0 30px rgba(241,195,107,0.6)" }}
            >
              {text}
            </motion.div>
            <motion.div
              initial={{ opacity: 0, scaleX: 0 }}
              animate={{ opacity: 1, scaleX: 1 }}
              transition={{ duration: 1, delay: 1.4 }}
              className="mx-auto mt-3 h-px w-40 bg-gradient-to-r from-transparent via-[var(--c-firefly-gold)] to-transparent"
            />
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.8, delay: 1.6 }}
              className="mt-3 text-[10px] sm:text-xs uppercase tracking-[0.5em] text-[var(--c-bio-green)]"
            >
              Pextlán · ecocomunidad
            </motion.div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
